export const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;
